import { LoginForm } from '@/features/auth';
import { Box } from '@/shared/ui';

export const LoginPage = () => {
  return (
    <Box sx={{ maxWidth: 450, width: '100%' }}>
      <LoginForm />
    </Box>
  );
};
